import React from 'react';
import PropTypes from 'prop-types';

import BaseContractModal from '../../BaseContractModal';
import LeadContractModalContent from './LeadContractModalContent';

const LeadContractModal = ({
  lead,
  coachId,
  showModal,
  onClose,
  isISView,
  showPostCommitmentConfiguration,
}) => (
  <BaseContractModal
    showModal={showModal}
    onClose={onClose}
  >
    <LeadContractModalContent
      lead={lead}
      coachId={coachId || lead.coach}
      onClose={onClose}
      showSendLinkOption={isISView}
      showPostCommitmentConfiguration={showPostCommitmentConfiguration}
    />
  </BaseContractModal>
);

LeadContractModal.propTypes = {
  lead: PropTypes.object.isRequired,
  coachId: PropTypes.string,
  showModal: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  isISView: PropTypes.bool,
  showPostCommitmentConfiguration: PropTypes.bool,
};

LeadContractModal.defaultProps = {
  coachId: null,
  isISView: false,
  showPostCommitmentConfiguration: false,
};

export default LeadContractModal;
